import DownloadInfo from './DownloadInfo';

export default DownloadInfo;
